export enum SettingsDynamicVariablesObjectsEnum {
  ADD_DYNAMIC_VARIABLE = 'add_dynamic_variable',
  DROPDOWN_NEW_DYNAMIC_VARIABLE = 'dropdown_new_dynamic_variable',
}
